import type { ICurrency } from '@bp/shared/models/currencies';
import type { DTO } from '@bp/shared/models/metadata';
import { Default, Label, MapFromDTO, Mapper, Unserializable } from '@bp/shared/models/metadata';

import { MerchantPsp, PspCredential } from '../../../psp';
import { PaymentOptionBase } from '../payment-option-base';

export abstract class PspPaymentOptionBase extends PaymentOptionBase {

	@MapFromDTO()
	pspId!: string;

	@Default([])
	merchantPspCredentialsIds!: string[];

	@Mapper(PspCredential)
	@Default([])
	@Label('Credentials')
	merchantPspCredentials!: PspCredential[];

	@Unserializable()
	merchantPsp!: MerchantPsp;

	@Unserializable()
	readonly hasActiveMids: boolean;

	abstract currencies: ICurrency[];

	override readonly isPspBased: boolean = true;

	constructor(dto?: DTO<PspPaymentOptionBase>) {
		super(dto);

		this.hasActiveMids = this.merchantPspCredentials.some(v => v.isEnabled);
	}

}
